import { render, staticRenderFns } from "./SubLogin.vue?vue&type=template&id=2e200b38&scoped=true"
import script from "./SubLogin.vue?vue&type=script&lang=js"
export * from "./SubLogin.vue?vue&type=script&lang=js"
import style0 from "./SubLogin.vue?vue&type=style&index=0&id=2e200b38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e200b38",
  null
  
)

export default component.exports